import { t } from '../services/language-manager';
import type { ProvisioningProgress as ProgressType } from '../services/wizard';

interface ProvisioningProgressProps {
  steps: ProgressType[];
}

const stepLabels: Record<string, { pending: string; done: string }> = {
  'oauth-client': { pending: 'progress-oauth', done: 'progress-oauth-done' },
  'register-org': { pending: 'progress-register', done: 'progress-register-done' },
  'update-credentials': { pending: 'progress-update-creds', done: 'progress-update-creds-done' },
};

function getStatusIcon(status: ProgressType['status']): string {
  switch (status) {
    case 'pending': return '\u25CB';
    case 'in-progress': return '\u25CF';
    case 'completed': return '\u2713';
    case 'failed': return '\u2717';
  }
}

export function ProvisioningProgress({ steps }: ProvisioningProgressProps) {
  return (
    <div className="card">
      <div className="card__title">{t('loading-installing')}</div>
      <div style={{ marginTop: '16px' }}>
        {steps.map((step) => {
          const labels = stepLabels[step.step];
          const label = step.status === 'completed' ? t(labels.done) : t(labels.pending);

          return (
            <div key={step.step} className="provision-step">
              <div className={`provision-step__icon provision-step__icon--${step.status}`}>
                {step.status === 'in-progress' ? (
                  <span className="spinner" style={{ width: '18px', height: '18px', borderWidth: '2px' }} />
                ) : (
                  getStatusIcon(step.status)
                )}
              </div>
              <div>
                <div className="provision-step__label">{label}</div>
                {step.error && (
                  <div className="provision-step__error">{step.error}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
